import { Api } from './BaseApi'
import { IHours, IStartEnd } from '../../types/System/IHours';
import { ICalendar } from '../../types/System/ICalendar';

const SystemApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getHours: build.query<IHours, void>({
            query: () => "System/Hours",
            providesTags: ["GetSystemHours"],
        }),
        getStartEnd: build.query<IStartEnd, void>({
            query: () => "System/StartEnd",
            providesTags: ["GetSystemStartEnd"],
        }),
        getWorkHours: build.query<ICalendar[], { slaId?: number, start: string, end: string }>({
            query: (props) => `System/WorkHours?slaid=${props.slaId || 0}&start=${props.start || ''}&end=${props.end || ''}`,
            providesTags: ["GetWorkHours"],
        }),
        getWorkDays: build.query<ICalendar[], { slaId?: number, start: string, end: string }>({
            query: (props) => `System/WorkDays?slaid=${props.slaId || 0}&dayStart=${props.start || ''}&dayEnd=${props.end || ''}`,
            providesTags: ["GetWorkDays"],
        }),
    }),

    overrideExisting: false,
})

export { SystemApi };